import axios from '@/utils/axios'
import queryString from '@/utils/queryString';
import salesByItemReport from './salesByItemReport';
import salesOrdersReport from './salesOrdersReport.js';

export default {
    namespaced: true,
    modules: {
        salesByItemReport,
        salesOrdersReport
    },
    state: {
       paymentCollection: null
    },
    mutations: {
        setPaymentCollection(state, payload) {
            state.paymentCollection = payload;
        }
    }, 
    actions: {
        getPaymentCollection({commit, dispatch, rootState}, payload) {
            let query = queryString(payload);
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "get",
                    url:`${rootState.sales.routePrefix}/payment-collection-report?${query}`,
                    headers: {Authorization: `Bearer ${rootState.authentication.token}`}
                })
                .then((response) => {
                    resolve(response.data);
                    commit('setPaymentCollection', response.data);
                })
                .catch((error) => {
                    if(error.response && error.response.status == 401) dispatch('authentication/logout',{ message: 'Session Expired! Please Login.' }, {root: true});
                    reject(error);
                })
            })
        },
        getCastingReport({dispatch, rootState}, payload) {
            let query = queryString(payload);
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "get",
                    url:`${rootState.sales.routePrefix}/casting-report?${query}`,
                    headers: {Authorization: `Bearer ${rootState.authentication.token}`}
                })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    if(error.response && error.response.status == 401) dispatch('authentication/logout',{ message: 'Session Expired! Please Login.' }, {root: true});
                    reject(error);
                })
            })
        },
        
    }
}